/**
 * Haptics (SPEC_CAPTURE_UX_R2 §8 #5): a short buzz on a good shot, a gentle double-buzz on retake — where the device
 * offers `navigator.vibrate` (Android browsers; iOS Safari does not). Never required, never awaited, never evidence.
 */

const GOOD_MS = 40;
const RETAKE_PATTERN: readonly number[] = [30, 60, 30];

function vibrate(pattern: number | readonly number[]): boolean {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return false;
  try {
    return navigator.vibrate(pattern as number | number[]) === true;
  } catch {
    return false;
  }
}

/** One short buzz — the shot cleared the on-device gate. Returns whether the device buzzed. */
export function hapticGoodShot(): boolean {
  return vibrate(GOOD_MS);
}

/** A gentle double-buzz — the representative chose (or was asked) to take it again. */
export function hapticRetake(): boolean {
  return vibrate(RETAKE_PATTERN);
}
